import {HTMLElementLinkedList} from "./html-element-linked-list";

export class HtmlWriter {
    /**
     * Cria uma instância de HtmlWriter a partir de uma string HTML
     * @param htmlString {string}
     */
    static fromHtmlString(htmlString) {
        return new HtmlWriter(HTMLElementLinkedList.fromHtmlString(htmlString));
    }

    /**
     * Lista ligada de elementos HTML
     * @type {HTMLElementLinkedList}
     */
    htmlElementLinkedList;
    /**
     * Container onde o texto será escrito
     * @type {HTMLElement}
     */
    container;

    /**
     * Intervalo de escrita
     * @type {number}
     */
    interval;

    /** @type {boolean} */
    _writing = false;

    constructor(
        htmlElementLinkedList,
        container,
        interval,
    ) {
        this.htmlElementLinkedList = htmlElementLinkedList;
        this.container = container;
        this.interval = interval || 15;
    }

    setElementLinkedList(htmlElementLinkedList) {
        this.htmlElementLinkedList = htmlElementLinkedList;

        return this;
    }

    /**
     * Define qual o nó vai receber o efeito de escrita
     * @param container {HTMLElement}
     * @returns {HtmlWriter}
     */
    setContainer(container) {
        this.container = container;

        return this;
    }

    write() {
        if (!this.isValid()) {
            console.error('HtmlWriter is not valid', this);

            return;
        }


        if (this.isWriting) return;

        this._writing = true;

        this.container.innerHTML = '';

        let currentNode = this.htmlElementLinkedList.head;
        let accumulator = '';

        const writeNode = () => {
            if (currentNode) {
                accumulator += currentNode.value;
                this.container.innerHTML = accumulator;
                currentNode = currentNode.next;
                setTimeout(writeNode, this.interval);
            } else {
                this._writing = false;
            }
        };

        writeNode();
    }

    /**
     * Escreve o conteúdo no container
     * @param container {HTMLElement}
     */
    writeTo(container) {
        this.setContainer(container);
        this.write();
    }

    isValid() {
        return this.htmlElementLinkedList instanceof HTMLElementLinkedList && this.container instanceof HTMLElement && this.interval > 0;
    }

    get isWriting() {
        return this._writing;
    }
}



// WEBPACK FOOTER //
// ./src/mixins/html-writer/html-writer.js